// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2641":"bb430654","3505":"558a627f","8353":"bb430654"}[chunkId] + ".chunk.css";
};